<template>
  <div class="space-y-2">
    <p>
      Voxbet (“we,” “our,” “us”) uses cookies and similar technologies to ensure our website
      <a href="https://betpic.com" class="text-blue-600 dark:text-blue-400 underline">betpic.com</a> operates securely and efficiently.
    </p>
    <p>
      This Cookie Policy explains what cookies and local storage are, how we use them, and how you can manage your preferences.
    </p>
    <p>
      By using our website — and particularly by signing up for an account or logging in — you consent to our use of cookies and local storage as described in this policy.
    </p>
    <p>
      Our website is intended only for users aged 18 years or older, or the legal betting age in their jurisdiction (whichever is higher).
    </p>
  </div>
</template>